// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { ReportFileStatusSchema } from '../inputTypeSchemas/ReportFileStatusSchema'

/////////////////////////////////////////
// REPORT FILE SCHEMA
/////////////////////////////////////////

export const ReportFileSchema = z.object({
  status: ReportFileStatusSchema,
  id: z.string(),
  tenantId: z.string().nullable(),
  reportId: z.string(),
  s3Bucket: z.string().nullable(),
  s3Key: z.string().nullable(),
  s3Etag: z.string().nullable(),
  s3Location: z.string().nullable(),
  name: z.string(),
  size: z.number().int(),
  originalSize: z.number().int().nullable(),
  mimeType: z.string().nullable(),
  encoding: z.string().nullable(),
  passwordEncrypted: z.string().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})

export type ReportFile = z.infer<typeof ReportFileSchema>

export default ReportFileSchema;
